<div class="privacy-content">
  <!--section -->
  <section class="parallax-section" data-scrollax-parent="true">
    <div class="bg1 par-elem " data-scrollax="properties: { translateY: '30%' }"
      style="background-color: gray; transform: translateZ(0px) translateY(-4.22535%);">
    </div>
    <!-- <img class="bg1 par-elem " src="assets/images/Contact.jpg" alt=""
      style="transform: translateZ(0px) translateY(-4.22535%);"> -->
    <div class="privacy-container">
      <div class="col-md-8 offset-md-2 text-center">
        <h2 class="section-title v1" style="color: white;
        font-size: 28px;
        font-weight: 600;
        margin-bottom: 0px;
        padding-bottom: 0px;">TERMS OF USE</h2>
      </div>
    </div>
  </section>
  <!-- section end -->
  <!--section -->
  <section class="gray-section" id="sec1">
    <div class="privacy-container">
      <div class="row">
        <div class="col-md-12">
          <div class="list-single-main-wrapper fl-wrap" id="sec2">
            <!-- article> -->
            <article>
              <div style="text-align: left;">
                <p>
                  Welcome to <a href="flexospaces.com">www.flexospaces.com</a>. This website and mobile applications are
                  owned and operated by Flexo Spaces. By visiting our website and mobile applications and accessing the
                  information, resources, services, products, and tools we provide, you understand and agree to accept
                  and adhere to the following terms and conditions as stated in this policy (hereinafter referred to as
                  the ‘Agreement’), along with the terms and conditions as stated in our Privacy Policy (please refer to
                  the Privacy Policy section below for more information).
                </p>
                <p class="pt-2">
                  We reserve the right to change this Agreement from time to time with/without notice. You acknowledge
                  and agree that it is your responsibility to review this Agreement periodically to familiarize yourself
                  with any modifications. Your continued use of this site after such modifications will constitute
                  acknowledgment and agreement of the modified terms and conditions.
                </p>
                <p class="pt-2">
                  <b>PLEASE READ THIS TERMS OF SERVICE AGREEMENT CAREFULLY. BY USING THIS WEBSITE OR ORDERING PRODUCTS
                    FROM THIS WEBSITE YOU AGREE TO BE BOUND BY ALL OF THE TERMS AND CONDITIONS OF THIS AGREEMENT.
                  </b>
                </p>
            
                <div class="list-single-main-item-title-1 fl-wrap terms">
                  <h3>
                    Scope of Agreement
                  </h3>
                </div>
                <p>
                  These Terms govern your use of the Platform, including browsing, enquiries, communications, and bookings.
                </p>
                <div class="list-single-main-item-title-1 fl-wrap terms">
                  <h3>
                     Responsible Use and Conduct
                  </h3>
                </div>
                <ul class="ul-1 pl-5">
                  <li>You must provide accurate, current, and complete information during registration or enquiry submission.</li>
                  <li>You are responsible for maintaining confidentiality of login credentials and all activities that occur under your account.</li>
                  <li>You agree not to:
                    <ul class="ul-2 pl-5">
                      <li>Access Platform content by unauthorized, automated, or unethical means</li>
                      <li>Disrupt servers, duplicate/copy/reproduce Platform content</li>
                      <li>Use Platform resources for illegal or unauthorized purposes.</li>
                    </ul>
                  </li>
                </ul>
                <div class="list-single-main-item-title-1 fl-wrap terms">
                  <h3>
                    Privacy
                  </h3>
                </div>
                <p>
                  Flexo strongly believes in protecting user privacy. Please refer to our Privacy Policy, incorporated herein by reference.
                </p>
                <div class="list-single-main-item-title-1 fl-wrap terms">
                  <h3>
                    Customer Communication
                  </h3>
                </div>
                <p>
                  By providing your contact information, you consent to receive communications from Flexo via email, phone calls, SMS, and WhatsApp, even if your number is registered under DND/NCPR under TRAI.
                </p>
                <ul>
                  <li>
                    You may opt out by:
                    <ol class="ul-3 pl-5">
                      <li>Using unsubscribe links in emails</li>
                      <li>Emailing us at hello@flexospaces.com</li>
                      <li>Communicating your preference during calls.</li>
                    </ol>
                  </li>
                </ul>
              
                <div class="list-single-main-item-title-1 fl-wrap terms">
                  <h3>
                   Services & Space Bookings
                  </h3>
                </div>
                <p>
                  The Platform enables you to search for, enquire about, and book workspaces (including short-term bookings such as hourly, daily, weekly, monthly, day passes, and virtual offices).
                </p>
                <ul class="ul-1 pl-5 pt-2">
                  <li>Flexo acts as a broker and intermediary and is not the operator of the spaces.</li>
                  <li>After you submit an enquiry or booking request, Flexo may share your details with internal teams, workspace partners, and broker partners to provide support and fulfillment.</li>
                  <li>Workspace providers may contact you directly.</li>
                </ul>
                <p class="pt-2">
                  If you book a space, you must:
                </p>
                <ul class="ul-1 pl-5 pt-2">
                  <li>Comply with the terms of use, rules, and payment obligations set by the host/provider.</li>
                  <li>Ensure responsible behavior while using the space.</li>
                </ul>
                <div class="list-single-main-item-title-1 fl-wrap terms">
                  <h3>
                    Refund Policy
                  </h3>
                </div>
                <p>
                  All refund requests, if any, will be handled per our Refund Policy available on the website.
                </p>
                <div class="list-single-main-item-title-1 fl-wrap terms">
                  <h3>
                    User Content & Posting
                  </h3>
                </div>
                <p>
                  By posting or submitting content on the Platform:
                </p>
                <ul class="ul-1 pl-5 pt-2">
                  <li>
                 
                      You grant Flexo a worldwide, royalty-free, perpetual license to use, display, publish, adapt, or distribute your content
                  
                  </li>
                  <li>
                
                     You must not post unlawful, defamatory, infringing, obscene, misleading, or unauthorized promotional content.
               
                  </li>
                  <li>
              
                      Flexo reserves the right to moderate or remove user content at its sole discretion.
              
                  </li>
        
                </ul>
                <div class="list-single-main-item-title-1 fl-wrap terms">
                  <h3>
                    Intellectual Property
                  </h3>
                </div>
                <ul class="ul-1 pl-5">
                  <li>All Platform content (text, images, design, software, trademarks, trade dress) is owned by or licensed to Flexo Proptech Pvt. Ltd.</li>
                  <li>You are granted a limited, non-exclusive, non-transferable license to use Platform content for <b>personal, non-commercial purposes.</b></li>
                </ul>
                <div class="list-single-main-item-title-1 fl-wrap terms">
                  <h3>
                    Third-Party Links
                  </h3>
                </div>
                <ul class="ul-1 pl-5">
                  <li>
                  
                      Flexo may display links to third-party sites for convenience.
                   
                  </li>
                  <li>
                   
                     Flexo disclaims liability for content, accuracy, or transactions occurring on third-party sites. Use at your own risk.
                 
                  </li>
                
                
                </ul>
                <div class="list-single-main-item-title-1 fl-wrap terms">
                  <h3>
                   Domestic Use
                  </h3>
                </div>
                <p>
                  Flexo makes no representation that Platform services or content are appropriate for use outside India. Users who access from other jurisdictions do so at their own risk and are responsible for compliance with local laws.
                </p>
                <div class="list-single-main-item-title-1 fl-wrap terms">
                  <h3>
                     Indemnity
                  </h3>
                </div>
                <p>
                  You agree to indemnify and hold harmless Flexo Proptech Pvt. Ltd., its directors, officers, employees, and agents from any claims, losses, damages, liabilities, or expenses (including attorneys' fees) arising from:
                </p>
              
                <ul class="ul-1 pl-5 pt-2">
                  <li>
                  
                      Your breach of these Terms
                 
                  </li>
                  <li>
                  
                     Your misuse of the Platform
                 
                  </li>
                  <li>
                
                      Your violation of any third-party rights or applicable laws.
                 
                  </li>
                 
                </ul>
                <div class="list-single-main-item-title-1 fl-wrap terms">
                  <h3>
                    Disclaimer of Warranties
                  </h3>
                </div>
               <ul class="ul-1 pl-5">
                <li>The Platform and its services are provided "as is" and "as available".</li>
                <li>Flexo disclaims all warranties of any kind, express or implied, including merchantability, fitness for purpose, or non-infringement</li>
               </ul>
                <div class="list-single-main-item-title-1 fl-wrap terms">
                  <h3>
                    Limitation of Liability
                  </h3>
                </div>
                <ul class="ul-1 pl-5">
                  <li>Flexo’s total liability shall not exceed the amount paid by you, if any, for use of the Platform.</li>
                  <li>Flexo shall not be liable for indirect, incidental, special, or consequential damages.</li>
                </ul>
                <div class="list-single-main-item-title-1 fl-wrap terms">
                  <h3>
                    Termination
                  </h3>
                </div>
                <p>
                  Flexo may terminate or suspend your access to the Platform at its sole discretion for breach of these Terms. Upon termination, all rights granted to you cease immediately.
                </p>
                <div class="list-single-main-item-title-1 fl-wrap terms">
                  <h3>
                    Force Majeure
                  </h3>
                </div>
                <p>
                 Flexo shall not be liable for any delay or failure in performance due to causes beyond its reasonable control, including acts of God, war, pandemic, strikes, lockouts, or Internet disruptions.
                </p>
                <div class="list-single-main-item-title-1 fl-wrap terms">
                  <h3>
                     Governing Law and Jurisdiction
                  </h3>
                </div>
                <p>
                  This Agreement is governed by and construed under the laws of India, with exclusive jurisdiction in the courts of <b>Mumbai, Maharashtra.</b> You waive any objection to jurisdiction, venue, or inconvenient forum.
                </p>
                <div class="list-single-main-item-title-1 fl-wrap terms">
                  <h3>
                     Statute of Limitations
                  </h3>
                </div>
                <p>
                  Any claim arising from use of the Platform must be brought within <b>one (1) year</b> from the cause of action.
                </p>
                <div class="list-single-main-item-title-1 fl-wrap terms">
                  <h3>
                    Waiver of Class Actions
                  </h3>
                </div>
                <p>
                  You waive any right to pursue claims as part of a class action.
                </p>
                <div class="list-single-main-item-title-1 fl-wrap terms">
                  <h3>
                     Assignment
                  </h3>
                </div>
                <p>
                  You may not assign your rights or obligations under these Terms without prior consent. Flexo may assign its rights at its discretion.
                </p>
               
                <div class="list-single-main-item-title-1 fl-wrap terms">
                  <h3>
                   Entire Agreement
                  </h3>
                </div>
                <p>
                 These Terms constitute the entire agreement between you and Flexo regarding the Platform, superseding any prior agreements.
                </p>
                <div class="list-single-main-item-title-1 fl-wrap terms">
                  <h3>
                     Contact Information
                  </h3>
                </div>
                <p>
                 If you have any questions about these Terms, email: hello@flexospaces.com
                </p>
               
                
              </div>
            </article>
          </div>
        </div>
        <!--box-widget-wrap -->
      </div>
    </div>
  </section>

  <!-- section end -->
</div>